import { makeAutoObservable } from 'mobx'

import { ShopRootStore } from 'shop/stores/shopRoot.store'
import {
  CURRENCY_COUNTRY_MAP,
  PAY_BY_BANK_COUNTRIES,
  STIPE_ELEMENT_OPTIONS_DEFAULT,
} from 'constants/paymentSettingShared.constants'
import { StripeElementsOptionsMode } from 'shop/types/stripe'
import { PAYMENT_PLANS } from 'constants/pricingPlans.constants'
import {
  StripePaymentMethod,
  StripePaymentMethodShop,
} from '../../interfaces/payment-method-interfaces/StripePaymentMethod'

export class ShopPayByBankPaymentMethodStore implements StripePaymentMethod, StripePaymentMethodShop {
  storeName = 'ShopPayByBankPaymentMethodStore'
  root: ShopRootStore = null

  constructor(root: ShopRootStore) {
    this.root = root

    makeAutoObservable(this)
  }

  isAppActive() {
    return this.root.experimentsStore.getFeatureGate('pay_by_bank_method')?.value
  }

  isAvailable = (activeCountry: string, currency: string): boolean =>
    PAY_BY_BANK_COUNTRIES.includes((activeCountry || 'DE').toUpperCase()) &&
    CURRENCY_COUNTRY_MAP[currency.toUpperCase()]?.includes(activeCountry)

  getStripeElementPayload = ({
    isDealsPage,
    isManagePage,
  }: {
    isDealsPage: boolean
    isManagePage: boolean
  }): StripeElementsOptionsMode => {
    if (isDealsPage) {
      return (
        (this.root.dealsStore?.getPayByBankStripeElementPayload &&
          this.root.dealsStore.getPayByBankStripeElementPayload()) ||
        STIPE_ELEMENT_OPTIONS_DEFAULT
      )
    } else if (isManagePage) {
      return (
        (this.root.ordersStore?.getPayByBankStripeElementPayload &&
          this.root.ordersStore.getPayByBankStripeElementPayload()) ||
        STIPE_ELEMENT_OPTIONS_DEFAULT
      )
    } else {
      return (
        (this.root.paymentStore?.getPayByBankStripeElementPayload &&
          this.root.paymentStore.getPayByBankStripeElementPayload()) ||
        STIPE_ELEMENT_OPTIONS_DEFAULT
      )
    }
  }

  isAvailableForPayerType = () => true

  isAvailableForPricingPlan = ({ withTestPeriod, withCustomStart, pricingPlanForm }) =>
    !withTestPeriod && !withCustomStart && pricingPlanForm === PAYMENT_PLANS.oneTime
}
